import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { map, Observable, Subscription } from 'rxjs';
import { CaseNote } from '../../../../models/ui/case-note.model';
import { MatDialog } from '@angular/material/dialog';
import { CaseNoteService } from '../../../../services/case-note.service';

@Component({
    selector: 'lex-case-notes-list',
    templateUrl: './case-notes-list.component.html',
    styleUrls: ['./case-notes-list.component.scss'],
    standalone: false
})
export class CaseNotesListComponent implements OnDestroy {
	public notes$: Observable<CaseNote[]> = this.caseNoteService.caseNotes$;
	public overMaxNoteLength$;
	public currentCaseNote: CaseNote = null;
	public rootSubscription = new Subscription();

	@ViewChild('searchBox', { static: false }) searchBoxElementRef: ElementRef;

	constructor(private caseNoteService: CaseNoteService, private dialog: MatDialog) {
		const currentCaseNoteSubscription = this.caseNoteService.currentCaseNote$.subscribe((note) => {
			this.currentCaseNote = note;
		});

		this.overMaxNoteLength$ = this.notes$.pipe(
			map((notes) => {
				return notes?.length >= 200;
			})
		);
		this.rootSubscription.add(currentCaseNoteSubscription);
	}

	public isSelected(note: CaseNote): boolean {
		return note?.id === this.currentCaseNote?.id;
	}

	public selectNote(note: CaseNote): void {
		this.caseNoteService.setCurrentCaseNote(note.id);
	}

	public filterNotes(searchTerm: string): void {
		this.caseNoteService.filterCaseNotes(searchTerm);
	}

	public clearSearch(): void {
		this.searchBoxElementRef.nativeElement.value = '';
		this.filterNotes(null);
	}

	public ngOnDestroy(): void {
		this.rootSubscription.unsubscribe();
	}
}

